module.exports = __webpack_public_path__ + "media/images/search_booking-fca179029112650fd43ac31eac45e6fe.gif";